var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgİconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54889 9.83657L10.9657 12.8988C11.0199 12.9687 11.0086 13.0703 10.9409 13.1267L9.09724 14.6048C8.70911 14.9117 8.23296 15.0358 7.77713 14.9884C7.31904 14.941 6.879 14.7199 6.56533 14.3362C5.33096 12.8266 4.21169 11.2041 3.22781 9.50033C2.24618 7.79885 1.39995 6.01838 0.709431 4.19279C0.533415 3.73018 0.562752 3.23824 0.75005 2.81851C0.937348 2.39653 1.28261 2.04901 1.74521 1.86848L3.94541 1.01097C4.0289 0.979378 4.12368 1.02 4.15527 1.10349L5.5995 4.73437C5.63335 4.81787 5.59047 4.91265 5.50924 4.94424L4.27713 5.4249C4.69234 6.32303 5.15946 7.2189 5.66269 8.09447L5.6672 8.10349C6.17042 8.97229 6.71201 9.82303 7.28067 10.6286L8.31194 9.80272C8.3819 9.7463 8.4857 9.75759 8.53986 9.82754L8.54889 9.83657ZM10.6092 12.9733L8.38867 10.1593L7.35063 10.992L7.34386 10.9965C7.27165 11.0484 7.1701 11.0326 7.1182 10.9581C6.50891 10.1028 5.92671 9.19795 5.38964 8.26597L5.38512 8.25694C4.84579 7.32496 4.3516 6.3659 3.91381 5.40684L3.9093 5.39556C3.87771 5.31207 3.91833 5.21729 4.00182 5.1857L5.23844 4.70278L3.91156 1.37203L1.8603 2.17087C1.48345 2.31755 1.19911 2.60414 1.04567 2.9494C0.892217 3.29466 0.86965 3.69859 1.01182 4.0777C1.69782 5.88976 2.53728 7.65443 3.50988 9.33786C4.48248 11.0235 5.59047 12.6302 6.81807 14.1309C7.07532 14.4446 7.43638 14.6273 7.81098 14.6657C8.18557 14.7063 8.57822 14.6025 8.89415 14.3498L10.6092 12.9733Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgİconPhone);
export default __webpack_public_path__ + "static/media/icon_phone.167ebcf27181323c5057b3ced3e9a94c.svg";
export { ForwardRef as ReactComponent };